// import { useMutation } from '@apollo/client'
import {
  GetProcessesDocument,
  UpdateProcessDocument,
  UpdateProcessMutation,
  UpdateProcessMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useUpdateProcess = () => {
  const [executeMutation, { loading }] = useMutation(UpdateProcessDocument, {
    extractorFn: (data: UpdateProcessMutation) => data.processesMutations.patchProcessesProcess,
  })

  return {
    loading,
    updateProcess(variables: UpdateProcessMutationVariables) {
      return executeMutation({
        variables,
        awaitRefetchQueries: true,
        refetchQueries: [
          {
            query: GetProcessesDocument,
          },
          {
            query: GetProcessesDocument,
            variables: {
              ids: [variables.id],
            },
          },
        ],
      })
    },
  }
}
